import * as React from 'react'
import { useCallback, useMemo, useState } from 'react'
import Stack from '@mui/material/Stack'
import MapBubbleContentsPestPac from '@user/features/MapView/MapBubbleContents/MapBubbleContentsPestPac'
import { KnockStatusModal } from '@user/features/MapView/KnockStatusModal'
import {
  EntityLocationDTO,
  PestPacMultiTenantLocation,
} from '@user/store/map/typings'
import { pestPacMemberToPin } from '@user/store/map/pestPacPin'
import { useAppDispatch } from '@user/store/hooks'
import { getAllKnockStatuses } from '@user/store/knockStatus/api'

export type Props = {
  member: PestPacMultiTenantLocation
  onViewFullDetails?: (location: EntityLocationDTO) => void
  onViewKnockStatusHistory?: (location: EntityLocationDTO) => void
  onRefresh?: () => void
}

function MultiTenantDrawerContentPestPac(props: Props) {
  const { member, onViewFullDetails, onViewKnockStatusHistory, onRefresh } =
    props
  const dispatch = useAppDispatch()
  const [knockStatusModalOpen, setKnockStatusModalOpen] = useState(false)

  const asPin = useMemo(() => pestPacMemberToPin(member), [member])

  const handleViewKnockStatusHistory = useCallback(
    (knockStatusLocationId: number) =>
      onViewKnockStatusHistory?.({ ...asPin, knockStatusLocationId }),
    [asPin, onViewKnockStatusHistory],
  )

  const handleKnockStatusClick = useCallback(() => {
    dispatch(getAllKnockStatuses())
    setKnockStatusModalOpen(true)
  }, [dispatch])

  const handleKnockStatusClose = useCallback(
    () => setKnockStatusModalOpen(false),
    [],
  )

  return (
    <Stack
      sx={{
        px: 2.4,
        pt: 0.8,
        pb: 1.1,
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <MapBubbleContentsPestPac
        location={asPin}
        viewLabel="View Full Details"
        showViewChevron={false}
        onKnockStatusClick={handleKnockStatusClick}
        onViewClick={
          onViewFullDetails ? () => onViewFullDetails(asPin) : undefined
        }
        onViewKnockStatusHistory={
          onViewKnockStatusHistory ? handleViewKnockStatusHistory : undefined
        }
        onKnockStatusCleared={onRefresh}
      />

      {knockStatusModalOpen && (
        <KnockStatusModal
          open={knockStatusModalOpen}
          onClose={handleKnockStatusClose}
          onDeleteSuccess={handleKnockStatusClose}
          onRefresh={onRefresh}
          address={asPin}
        />
      )}
    </Stack>
  )
}

export default MultiTenantDrawerContentPestPac
